import { websiteShortCode } from '../environment';
import { IAppState } from './models';

let ogDescription: string = '';
let ogTitle: string = '';
let ogImage: string = '';
let ogUrl: string = '';
let ogType: string = '';
let ogSiteName: string = '';
let ogTwitterTitle: string = '';
let ogTwitterDescription: string = '';
let ogTwitterImage: string = '';
let ogTwitterCard: string = '';
let ogTwitterSite: string = '';
let ogTwitterCreator: string = '';
let robots: string = 'index, follow';
let themeColor: string = '';

switch (websiteShortCode()) {
    case 'DS':
        ogDescription = 'The best experience, bar none. Buy, sell, boost, and swap your video game assets in minutes. Trade with us directly, and avoid middleman fees. Best prices guaranteed!';
        ogTitle = 'DivicaSales';
        ogImage = 'https://divicasales.com/seo/thumbnail.png';
        ogUrl = 'https://divicasales.com/blog/';
        ogType = 'website';
        ogSiteName = 'DivicaSales';
        ogTwitterTitle = 'DivicaSales';
        ogTwitterDescription = 'The best experience, bar none. Buy, sell, boost, and swap your video game assets in minutes. Trade with us directly, and avoid middleman fees. Best prices guaranteed!';
        ogTwitterImage = 'https://divicasales.com/seo/thumbnail.png';
        ogTwitterCard = 'summary_large_image';
        ogTwitterSite = '@DivicaSales';
        ogTwitterCreator = '@DivicaSales';
        themeColor = '#5865F2';
        break;
    case 'CG':
        ogDescription = 'Your destination to buy, sell, boost, and swap your video game assets in minutes. Trade with us directly, and avoid middleman fees. Best prices guaranteed!';
        ogTitle = 'ChicksGold';
        ogImage = 'https://chicksgold.com/seo_thumbnail.png';
        ogUrl = 'https://chicksgold.com/blog/';
        ogType = 'website';
        ogSiteName = 'ChicksGold';
        ogTwitterTitle = 'ChicksGold';
        ogTwitterDescription = 'Your destination to buy, sell, boost, and swap your video game assets in minutes. Trade with us directly, and avoid middleman fees. Best prices guaranteed!';
        ogTwitterImage = 'https://chicksgold.com/seo_thumbnail.png';
        ogTwitterCard = 'summary_large_image';
        ogTwitterSite = '@ChicksGold';
        ogTwitterCreator = '@ChicksGold';
        themeColor = '#39e29e';
        break;
    case 'CX':
        ogDescription = 'Buy and Sell Cryptocurrency from ChicksX, the leading cryptocurrency provider serving global markets including Canada and the United States.';
        ogTitle = 'ChicksX';
        ogImage = 'https://chicksx.com/seo/thumbnail.png';
        ogUrl = 'https://chicksx.com/blog/';
        ogType = 'website';
        ogSiteName = 'ChicksX';
        ogTwitterTitle = 'ChicksX';
        ogTwitterDescription = 'Buy and Sell Cryptocurrency from ChicksX, the leading cryptocurrency provider serving global markets including Canada and the United States.';
        ogTwitterImage = 'https://chicksx.com/seo/thumbnail.png';
        ogTwitterCard = 'summary_large_image';
        ogTwitterSite = '@ChicksX';
        ogTwitterCreator = '@ChicksX';
        themeColor = '#00338c';
        break;
    case 'GT':
        ogDescription = 'The best experience, bar none. Buy, sell, boost, and swap your video game assets in minutes. Trade with us directly, and avoid middleman fees. Best prices guaranteed!';
        ogTitle = 'GamerTotal';
        ogImage = 'https://gamertotal.com/seo/thumbnail.png';
        ogUrl = 'https://gamertotal.com/blog/';
        ogType = 'website';
        ogSiteName = 'GamerTotal';
        ogTwitterTitle = 'GamerTotal';
        ogTwitterDescription = 'The best experience, bar none. Buy, sell, boost, and swap your video game assets in minutes. Trade with us directly, and avoid middleman fees. Best prices guaranteed!';
        ogTwitterImage = 'https://gamertotal.com/seo/thumbnail.png';
        ogTwitterCard = 'summary_large_image';
        ogTwitterSite = '@GamerTotal';
        ogTwitterCreator = '@GamerTotal';
        themeColor = '#ee6d32';
        break;
    default:
        break;
}

export const initialState: IAppState = {
    metadata: {
        ogDescription,
        ogTitle,
        ogImage,
        ogUrl,
        ogType,
        ogSiteName,
        ogTwitterTitle,
        ogTwitterDescription,
        ogTwitterImage,
        ogTwitterCard,
        ogTwitterSite,
        ogTwitterCreator,
        robots,
        themeColor,
        pagination: { count: 0, page: 0 }
    },
    router: {
        currentUrl: '',
        routeName: ''
    },
    currency: {
        selectedCurrency: 'USD'
    },
    currencyPage: {
        selectedGame: undefined,
        product: undefined,
        pricePerUnit: 0,
        quantity: 0,
        totalPrice: 0
    }
};
